module.exports = __webpack_public_path__ + "assets/img/pv.eeb8a776.jpg";